var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccident = function SvgAccident(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.725 25.717A8.95 8.95 0 0 0 3 31v10a4 4 0 0 0 4 4h7.746ZM29 42a2.994 2.994 0 0 0-3-3h-1.866l3 5.773A3 3 0 0 0 29 42"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 12,
    r: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45 13.04 22H12a8.96 8.96 0 0 0-5.834 2.154L17 45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.787 26.069c.835-.09 1.661-.217 2.48-.363A8.98 8.98 0 0 0 30 22h-2.08a12.96 12.96 0 0 1-12.162.892L23.094 37H26a5 5 0 0 1 0 10H10v14h10v-8h2v8h10V47h2.359A21.2 21.2 0 0 1 33 39.564v-13.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24.172a36.9 36.9 0 0 1-13 3.886v11.505a20.29 20.29 0 0 0 13 18.609 20.29 20.29 0 0 0 13-18.609V28.058a36.9 36.9 0 0 1-13-3.886m-2.293 22.707a1 1 0 0 1-1.414 0l-5-5 1.414-1.414L45 44.758l10.293-10.293 1.414 1.414Z"
  })));
};
export default SvgAccident;